/**
 * Converts the given string to the string that matches the pattern.
 * @param value String value to process.
 * @param pattern Validation pattern.
 */
export function escape(value: string, pattern: string): string {
  let result = '';

  if (value) {
    const regex = new RegExp(pattern);

    for (const c of value) {
      if (regex.test(c))
        result
          += c;
    }

    result = result.trim();
  }

  return result;
}
